import clsx from "clsx"
import { isMobileOnly } from "react-device-detect"
import { FAQIcon } from "../Icons"
import "./HelpInfo.scoped.scss"

export const HelpInfo = ({ children }) => {
	return <div className={clsx("c-help", { "flex flex-col": isMobileOnly })}>{children}</div>
}
